import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { RequestDataAccessServiceConfig } from './request-data-access.service';
import { CredentialsFactory } from 'authorization';
import { map } from 'rxjs/operators';
import { PassportsStore, PassportNumber } from 'types';
import { Injectable } from '@angular/core';
import { CouchDbRepository } from './base/couchdb-repository';

@Injectable()
export class CouchDbPassportsStore implements PassportsStore {
  private _repo: CouchDbRepository<PassportNumber>;

  constructor(
    private _httpClient: HttpClient,
    private _config: RequestDataAccessServiceConfig,
    private _credentialsFactory: CredentialsFactory,
  ) {
    this._repo = new CouchDbRepository<PassportNumber>(
      (x: PassportNumber) => x.SerialNumber,
      (row: any) => {
        if (!!row.SerialNumber) {
          return PassportNumber.fromString(row.SerialNumber);
        }
        return PassportNumber.fromString(row._id);
      },
      'passports',
      this._httpClient,
      this._config,
      this._credentialsFactory,
    );
  }

  getGrantedPassports(): Observable<PassportNumber> {
    return this._repo.getAll$();
  }

  removeGrantedPassport(number: PassportNumber): Observable<boolean> {
    return this._repo.remove$(number.SerialNumber);
  }

  saveGrantedPassport(number: PassportNumber): Observable<boolean> {
    return this._repo.store$(number).pipe(map((x) => !!x));
  }
}
